import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const mailerRoutes = [
  {
    path: 'mailer',
    component: () => import('@/features/mailer/common/MailerParentLayout.vue'),
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.MailerView,
    },
    children: [
      {
        path: '',
        component: () => import('@/features/mailer/mailerMain/MailerMain.vue'),
        meta: { permissionAction: PermissionActions.MailerView },
      },
      {
        path: 'mobile/editor/:emailTemplateId',
        component: () => import('@/features/mailer/mailerMobile/MailerMobile.vue'),
        meta: { permissionAction: PermissionActions.MailerView },
      },
      {
        path: 'mobile/editor/new',
        component: () => import('@/features/mailer/mailerMobile/MailerMobile.vue'),
        meta: { permissionAction: PermissionActions.MailerMobileCreate },
      },
      {
        path: 'editor/:emailTemplateId',
        component: () => import('@/features/mailer/mailerEditorView/MailerEditorView.vue'),
        meta: { permissionAction: PermissionActions.MailerView },
      },
      {
        path: 'editor/new',
        component: () => import('@/features/mailer/mailerEditorView/MailerEditorView.vue'),
        meta: { permissionAction: PermissionActions.MailerCreate },
      },
      {
        path: 'drafts',
        component: () => import('@/features/mailer/mailerDrafts/MailerDrafts.vue'),
        meta: { permissionAction: PermissionActions.MailerDraftsView },
      },
      {
        path: 'history',
        component: () => import('@/features/mailer/mailerHistory/MailerHistory.vue'),
        meta: { permissionAction: PermissionActions.MailerHistoryView },
      },
      {
        path: 'history/:sentEmailId',
        component: () => import('@/features/mailer/mailerHistory/MailerHistoryDetail.vue'),
        meta: { permissionAction: PermissionActions.MailerHistoryView },
      },
      {
        path: 'mailing-list',
        component: () => import('@/features/mailer/mailerMailingList/MailerMailingList.vue'),
        meta: { permissionAction: PermissionActions.MailerMailingListsView },
      },
      {
        path: 'mailing-list/:mailingListId',
        component: () => import('@/features/mailer/mailerMailingList/MailerMailingListDetail.vue'),
        meta: { permissionAction: PermissionActions.MailerMailingListsView },
      },
      {
        path: 'system-emails',
        component: () => import('@/features/mailer/mailerSystemEmails/MailerSystemEmails.vue'),
        meta: { permissionAction: PermissionActions.MailerSystemEmailsView },
      },
      {
        path: 'template-settings',
        component: () =>
          import('@/features/mailer/mailerTemplateSettings/MailerTemplateSettings.vue'),
        meta: { permissionAction: PermissionActions.MailerTemplateSettingsView },
      },
      {
        path: 'template-update',
        component: () => import('@/features/mailer/mailerTemplateUpdate/MailerTemplateUpdate.vue'),
        meta: { permissionAction: PermissionActions.MailerTemplateSettingsView },
      },
      {
        path: 'archived',
        component: () => import('@/features/mailer/mailerArchivedList/MailerArchivedList.vue'),
        meta: { permissionAction: PermissionActions.MailerView },
      },
      {
        path: 'scheduled',
        component: () => import('@/features/mailer/mailerScheduledList/MailerScheduledList.vue'),
        meta: { permissionAction: PermissionActions.MailerSchedule },
      },
      {
        path: 'create-email',
        component: () => import('@/features/mailer/mailerCreateEmail/MailerCreateEmail.vue'),
        meta: { permissionAction: PermissionActions.MailerCreate },
      },
    ],
  },
]
